module.exports = __webpack_public_path__ + "img/hr-heated-corner-up-left-4.7557842d.png";